import { render, staticRenderFns } from "./Otros.vue?vue&type=template&id=ebe57c9e&"
import script from "./Otros.vue?vue&type=script&lang=js&"
export * from "./Otros.vue?vue&type=script&lang=js&"
import style0 from "./Otros.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports